export const HEADER_BADGE_POLL_MS = 30 * 1000

/** Roda `fn` já, a cada `ms` (só com a aba visível) e de novo ao voltar para a aba. */
export function startBadgePoll(fn, ms = HEADER_BADGE_POLL_MS) {
  fn()
  const tick = () => {
    if (document.visibilityState === 'visible') fn()
  }
  const id = setInterval(tick, ms)
  document.addEventListener('visibilitychange', tick)
  return () => {
    clearInterval(id)
    document.removeEventListener('visibilitychange', tick)
  }
}
